import { ExecuteCommandBody } from '@types'

export const transformBodyByHttpMethod = (
  method: string,
  body: ExecuteCommandBody | FormData | undefined
) => {
  if (method === 'GET' || method === 'HEAD') {
    return undefined
  }

  return body
}
